import React from "react";
import "./Button.css";

const Button = ({ text, type, disabled }) => {
  console.log(disabled);
  return (
    <div className="button_container">
      <button type={type} className="main_button" disabled={disabled}>
        {text}
      </button>
    </div>
  );
};

export default Button;
